export default __webpack_public_path__ + "d15a40adad0608457e3687d4d128e912.png";